import script from "./newsOverviewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./newsOverviewV2.vue?vue&type=script&setup=true&lang=js"

import "./newsOverviewV2.vue?vue&type=style&index=0&id=795cf26b&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795cf26b"]])

export default __exports__